export default __webpack_public_path__ + "static/custom-51d0abcd3d6c0aed412d4fd57af64f7b.png";